import { LazyExoticComponent } from "react";
import { RouteName } from "../../constants/route_name";

export type JSXComponent = () => JSX.Element;

export interface Route {
    to: string;
    key: RouteName | undefined;
    path: string;
    name: string;
    Component: LazyExoticComponent<JSXComponent> | JSXComponent;
    redirectPath?: string;
    role?: Auth[];
}

export enum Auth {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_USER = "ROLE_USER",
    ROLE_DEVELOPER = "ROLE_DEVELOPER",
    ROLE_SUPPORT = "ROLE_SUPPORT",
    ROLE_MANAGER = "ROLE_MANAGER",
    ROLE_OUTCAST = "ROLE_OUTCAST",
}

